/**
 * Creates a filter change handler that resets pagination
 */
export const createFilterChangeHandler = (
  setPage: (page: number) => void,
  onFilterChange?: (name: string, value: any) => void
) => {
  return (name: string, value: any) => {
    setPage(1); // Reset to beginning when filter changes
    onFilterChange?.(name, value);
  };
};
